<div class="integration-center">
   <div class="flex-align-center" style="gap: 5rem;">
       <div>
           <img src="../../../../assets/svg/quickbook_logo_official.png" style="width: 233px; height; 70px;" alt="">
       </div>
       <div class="text-center">
           <h5>Connecting to QuickBooks ....</h5>
           <p>This window will close in&nbsp;{{time}}&nbsp;seconds...</p>
       </div>
       <div>
           <img src="../../../../assets/svg/table/Fieldex_Bg.svg" class="w-70px" alt="">
       </div>
   </div>
</div>